import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export const TagStatus = ({ color, text, textColor = 'rgba(6, 12, 25, 0.45)', status = 'default', style, className, onMouseEnter, onMouseLeave, }) => (_jsxs(Wrapper, Object.assign({ textColor: textColor, style: style, className: className, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, { children: [_jsx(Sign, { status: status, color: color }, void 0), text] }), void 0));
const Wrapper = styled.span `
  position: relative;
  padding-left: 14px;
  color: ${props => props.textColor};
  font-weight: bold;
  font-size: 13px;
  line-height: 18px;
  white-space: nowrap;
`;
/*
 * why not 伪元素
 * 因为 html2canvas 无法打印伪元素
 */
const Sign = styled.span `
  position: absolute;
  top: 50%;
  left: 0;
  width: 8px;
  height: 8px;
  background-color: ${({ status, color, theme }) => {
    if (color)
        return color;
    switch (status) {
        case 'ongoing':
            return theme.status.ongoing.element;
        case 'success':
            return theme.status.success.element;
        case 'warning':
            return theme.status.warning.element;
        case 'danger':
            return theme.status.danger.element;
        case 'invalid':
            return theme.status.invalid.element;
        default:
            return theme.text._3;
    }
}};
  border-radius: 50%;
  transform: translateY(-50%);
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvVGFnU3RhdHVzL2luZGV4LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBS0EsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUE7QUErQnRDLE1BQU0sQ0FBQyxNQUFNLFNBQVMsR0FBdUIsQ0FBQyxFQUM1QyxLQUFLLEVBQ0wsSUFBSSxFQUNKLFNBQVMsR0FBRyx1QkFBdUIsRUFDbkMsTUFBTSxHQUFHLFNBQVMsRUFDbEIsS0FBSyxFQUNMLFNBQVMsRUFDVCxZQUFZLEVBQ1osWUFBWSxHQUNiLEVBQUUsRUFBRSxDQUFDLENBQ0osTUFBQyxPQUFPLGtCQUNOLFNBQVMsRUFBRSxTQUFTLEVBQ3BCLEtBQUssRUFBRSxLQUFLLEVBQ1osU0FBUyxFQUFFLFNBQVMsRUFDcEIsWUFBWSxFQUFFLFlBQVksRUFDMUIsWUFBWSxFQUFFLFlBQVksaUJBRTFCLEtBQUMsSUFBSSxJQUFDLE1BQU0sRUFBRSxNQUFNLEVBQUUsS0FBSyxFQUFFLEtBQUssV0FBSSxFQUNyQyxJQUFJLGFBQ0csQ0FDWCxDQUFBO0FBRUQsTUFBTSxPQUFPLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBdUI7OztXQUd2QyxLQUFLLENBQUMsRUFBRSxDQUFDLEtBQUssQ0FBQyxTQUFTOzs7OztDQUtsQyxDQUFBO0FBRUQ7OztHQUdHO0FBQ0gsTUFBTSxJQUFJLEdBQUcsTUFBTSxDQUFDLElBQUksQ0FBcUM7Ozs7OztzQkFNdkMsQ0FBQyxFQUFFLE1BQU0sRUFBRSxLQUFLLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRTtJQUMvQyxJQUFJLEtBQUs7UUFBRSxPQUFPLEtBQUssQ0FBQTtJQUV2QixRQUFRLE1BQU0sRUFBRTtRQUNkLEtBQUssU0FBUztZQUNaLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFBO1FBQ3JDLEtBQUssU0FBUztZQUNaLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFBO1FBQ3JDLEtBQUssU0FBUztZQUNaLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFBO1FBQ3JDLEtBQUssUUFBUTtZQUNYLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFBO1FBQ3BDLEtBQUssU0FBUztZQUNaLE9BQU8sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFBO1FBQ3JDO1lBQ0UsT0FBTyxLQUFLLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQTtLQUN2QjtBQUNILENBQUM7OztDQUdGLENBQUEifQ==